import { useContext, useMemo } from 'react';
import { PlayTimerContext, DEFAULT_TIMER, DEFAULT_TIMER_NUM } from '@gameday/utils/providers/PlayTimerProvider';
const defaultConfig = { timer: DEFAULT_TIMER, timerNum: DEFAULT_TIMER_NUM };

const usePlayTimer = () => {
    const context = useContext(PlayTimerContext);
    return useMemo(() => {
        return !context?.timer ? defaultConfig : context;
    }, [context]);
};

export default usePlayTimer;
